import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import {MatchLocaleModule} from '../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'app-copy-toast-notification',
  standalone: true,
  imports: [RouterModule, TranslateModule, MatchLocaleModule],
  templateUrl: './copy-toast-notification.component.html',
})
export class CopyToastNotificationComponent {
  @Input() selectedListAndItem: any;
  @Output() closeModal = new EventEmitter<boolean>();
  PAGES_AND_PATHS = PAGES_AND_PATHS;

}
